<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="admin-page-content">
                <!--class = "admin-page-content sidebar-right"-->
                <!-- Location Contact details Start -->
                <div class="main-location-area default-bx-shadow">
                    <div class="location-title">
                        {{departmentData[0].site_name}}
                    </div>
                    <template v-if="departmentData[0].site_note != '' || departmentData[0].site_address_line != '' || departmentData[0].site_contacts.length > 0">
                        <div class="location-address">
                            <img src="/static/images/map-pin.png"> <p>{{departmentData[0].site_address_line}}</p>
                        </div>
                        <div class="main-location-area-details">
                            <div v-if="departmentData[0].site_note != ''" class="main-location-block">
                                <strong>Note</strong>
                                <p>{{departmentData[0].site_note}}</p>
                            </div>
                            <template v-if="departmentData[0].site_contacts.length > 0">
                                <div v-show="departmentData[0].site_contacts[0].contact_label != ''" class="main-location-block">
                                    <strong>{{departmentData[0].site_contacts[0].contact_label}}</strong>
                                    <p>{{departmentData[0].site_contacts[0].contact}}</p>
                                </div>
                                <template v-show="departmentData[0].site_contacts.length > 1">
                                    <template v-for="(cont, index) in departmentData[0].site_contacts">
                                        <template v-if="index != 0">
                                            <div class="main-location-block">
                                                <strong v-if="cont.contact_label != ''">{{cont.contact_label}}</strong>
                                                <p>{{cont.contact}}</p>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="main-location-area-details">
                            <div class="main-location-block">
                                <p>{{noDataMessaage}}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- Location Contact details End -->
                <!-- Department wise contact list Start -->
                <template v-for="(dept_cont, index) in departmentData">
                    <template v-if="dept_cont.department_id != 0">
                        <div class="department-container">
                            <div class="department-block row-department">
                                <div class="department-name">
                                    {{dept_cont.dept_name}}
                                </div>
                                <template v-if="dept_cont.note !='' || dept_cont.address_line != '' || dept_cont.contacts.length > 0">
                                    <div v-if="dept_cont.address_line != ''" class="department-address">
                                        <img src="/static/images/map-pin.png"> 
                                        <p>{{dept_cont.address_line}}</p>
                                    </div>
                                    <div class="department-details">
                                        <p v-if="dept_cont.note != ''">
                                            <strong>Note :</strong> {{dept_cont.note}}
                                        </p>
                                        <p v-show="dept_cont.contacts[0].contact_label != ''">
                                            <strong>{{dept_cont.contacts[0].contact_label}} :</strong> {{dept_cont.contacts[0].contact}}
                                        </p>
                                        <template v-if="dept_cont.contacts.length > 1">
                                            <template v-for="(cont, index1) in dept_cont.contacts">
                                                <template v-if="index1 != 0">
                                                    <p>
                                                        <strong v-if="cont.contact_label != ''">{{cont.contact_label}} :</strong> {{cont.contact}}
                                                    </p>
                                                </template>
                                            </template>
                                        </template>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="department-details">
                                        <p>{{noDataMessaage}}</p>
                                    </div>
                                </template>
                                <!-- Employee Contact Details Start -->
                                <template v-for="(user_cont, index_user) in rows">
                                    <template v-if="user_cont.department_id == dept_cont.department_id">
                                        <template v-if="user_cont.id != 0">
                                            <div class="department-user">
                                                <div class="department-name" >
                                                    <template v-if="user_cont.user != '' && user_cont.user != null">
                                                        {{user_cont.user}}
                                                    </template>
                                                    <template v-else>
                                                        No Name
                                                    </template>
                                                </div>
                                                <template v-if="user_cont.address_line != '' || user_cont.note != '' || user_cont.email != '' || user_cont.contacts.length > 0 || user_cont.contact != ''">
                                                    <div class="department-details">
                                                        <p v-if="user_cont.address_line != ''">
                                                            <strong>Address :</strong> {{user_cont.address_line}}
                                                        </p>
                                                        <p v-if="user_cont.note != ''" >
                                                            <strong>Note :</strong> {{user_cont.note}}
                                                        </p>
                                                        <p v-if="user_cont.email != '' && user_cont.email != null">
                                                            <strong>Email :</strong> {{user_cont.email}}
                                                        </p>
                                                        <template v-if="user_cont.contacts.length > 0 || user_cont.contact != ''">
                                                            <p v-if="user_cont.contact != ''">
                                                                <strong >Extension :</strong> {{user_cont.contact}}
                                                            </p>
                                                            <template v-for="(cont, index1) in user_cont.contacts">
                                                                <p>
                                                                    <strong v-if="cont.contact_label != ''">{{cont.contact_label}} :</strong> {{cont.contact}}
                                                                </p>
                                                            </template>
                                                        </template>
                                                    </div>    
                                                </template>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                                <!-- Employee Contact Details Start -->
                            </div>
                        </div>
                    </template>
                </template>
                <!-- Department wise contact list End -->
            </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import EventBus from '../../../event-bus';
    import SessioMixin from '../../../../mixins/sessionmixin';
    import { HTTP } from '../../../../http-common';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'app-backend-footer': BackendFooter,
            swiper,
            swiperSlide,
        },
        mixins: [SessioMixin],
        data() {
            return {
                hideContactflag: false,
                userData: {
                    id: 0
                },
                departmentData: [{
                        site_contacts: []
                    }
                ],
                windowWidth: 0,
                noDataMessaage: 'Details not available',
                display_sidebar_on_load: false,
                department_id: 0,
                location: '',
                company: '',
                selected_menu_data: '',
                user_name: '',
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                sitesArr: [],
                firstLoad: 0,
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'user',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin(window.location.href);
            var contactDetailOpen = localStorage.getItem("contact_detail_open");
            if (contactDetailOpen == 'true') {
                self.hideContactflag = false;
            } else {
                self.hideContactflag = true;
            }
            //self.checkLogin();
        },
        mounted: function () {
            //            self = this;
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                }
            });

            self.company = this.$route.params.company;
            self.location = this.$route.params.location;
            self.getPermissions();
            self.$nextTick(function () {
                self.loadLocationDepartment(self.company, self.location);
            });
            /*self.getMenus();*/
        },
        watch: {
            '$route'(to, from) {
                self.location = this.$route.params.location;
                self.company = this.$route.params.company;
                self.$nextTick(function () {
                    self.loadLocationDepartment(self.company, self.location);
                });
                self.userData = {id: 0};
                /*console.log(self.location);*/
            }
        },
        methods: {
            selectDepartment(id) {
                $('.contacttDetails').hide();
                self.department_id = id;
                if (self.department_id) {
                    self.userData = {id: 0};
                }
                self.$nextTick(function () {
                    self.loadContacts();
                });
            },
            loadLocationDepartment(company, location) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        company: company,
                        location: location,
                        swiper: 1,
                    }
                };
                self.showLoader();
                HTTP.get("ce-getsitedepartment", config)
                        .then(function (response) {
                            self.departmentData = [];
                            // if (response.data.content.length > 0) {
                            $.each(response.data.content, function (i) {
                                if (i == 0) {
                                    self.selectDepartment(response.data.content[i].department_id);
                                }
                                self.departmentData.push(response.data.content[i]);
                            });
                            if (self.departmentData[0].site_note != '' || self.departmentData[0].site_address_line != '' || self.departmentData[0].site_contacts.length > 0) {
                                $(".page-sidebar").removeAttr("style");
                                setTimeout(function () {
                                    EventBus.$emit('blink-detail', true, true, );
                                }, (self.ContactSideDetailAutoCloseSeconds * 1000));
                            }
                            // }

                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
                /*setTimeout(function () {
                 window.print();
                 },1500);*/
            },
            loadContacts: function () {
                $('.contacttDetails').hide();
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        department_id: self.department_id,
                        site_id: self.location,
                    }
                };
                self.showLoader();
                HTTP.get('listcontactprint', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.hideLoader();
                        })
                self.$nextTick(function () {
                    $("title").html("Contact Directory For " + self.departmentData[0].site_name);
                });
                setTimeout(function () {
                    window.print();
                }, 1500);
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
    EventBus.$on('blink-detail', function (isLogin, is_blink) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.display_sidebar_on_load = is_blink;
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/backend/contactextension/print/PrintContactList.vue